import { render, staticRenderFns } from "./DeadlinesAdmin.vue?vue&type=template&id=623103f9&scoped=true"
import script from "./DeadlinesAdmin.vue?vue&type=script&lang=js"
export * from "./DeadlinesAdmin.vue?vue&type=script&lang=js"
import style0 from "./DeadlinesAdmin.vue?vue&type=style&index=0&id=623103f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623103f9",
  null
  
)

export default component.exports